import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [terminalInfo, setTerminalInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored terminal info on mount
    const terminalKey = localStorage.getItem('terminalSecretKey');
    const storedInfo = localStorage.getItem('terminalInfo');
    
    if (terminalKey && storedInfo) {
      try {
        setTerminalInfo(JSON.parse(storedInfo));
      } catch (error) {
        console.error('Failed to parse stored terminal info:', error);
        localStorage.removeItem('terminalSecretKey');
        localStorage.removeItem('terminalInfo');
      }
    }
    
    setLoading(false);
  }, []);

  const login = async (terminalSecretKey) => {
    try {
      const response = await authAPI.login(terminalSecretKey);
      const info = response.data.terminal || response.data.location;
      
      localStorage.setItem('terminalSecretKey', terminalSecretKey);
      localStorage.setItem('terminalInfo', JSON.stringify(info));
      setTerminalInfo(info);
      
      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || error.response?.data?.error || 'Login failed'
      };
    }
  };

  const logout = () => {
    authAPI.logout();
    setTerminalInfo(null);
  };

  const value = {
    terminalInfo,
    loading,
    login,
    logout,
    isAuthenticated: !!terminalInfo
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
